import { decodeHTML } from 'helpers/utils'
import { TAG_LOCATOR_REGEX, TAGS_ONLY_REGEX, OPENING_TAGS_REGEX, CLOSING_TAGS_REGEX, SPECIAL_CHARACTERS_ESCAPE_REGEX } from './constants'

export const getCleanText = text =>
  text ? decodeHTML(text).replace(TAGS_ONLY_REGEX, ' ').replace(/ {2}/g, ' ') : ''

export const truncate = (text, limit, endtext) => {
  const trimmedEnd = getCleanText(text).length > limit && endtext ? endtext : ''
  const taglessShortText = getCleanText(text).substr(0, limit)
    .replace(SPECIAL_CHARACTERS_ESCAPE_REGEX, (m) => `\\${m}`)
  const matchedShortHtml = decodeHTML(text).trim().match(new RegExp(TAG_LOCATOR_REGEX + taglessShortText
    .replace(/ /g, TAG_LOCATOR_REGEX) + TAG_LOCATOR_REGEX))

  if (!matchedShortHtml) {
    return ''
  }
  const tagsInSubstring = matchedShortHtml[0].match(TAGS_ONLY_REGEX)
  let openingTags = []

  if (tagsInSubstring) {
    tagsInSubstring.forEach(item => {
      if (item.match(CLOSING_TAGS_REGEX)) {
        openingTags.splice(openingTags.lastIndexOf(item.replace(/[<>/]/g, '')), 1)
      } else if (item.match(OPENING_TAGS_REGEX)) {
        openingTags.push(item.replace(/[<>]/g, '').split(' ')[0])
      }
    })
  }

  openingTags = openingTags.reverse()
  return openingTags.reduce((target, tag) => `${target}</${tag}>`, `${matchedShortHtml[0]}${trimmedEnd}`)
}

export const flatten = arrays => [].concat(...arrays)
